
 <div class="home-container">
  <div class="empower-future-wrapper">
    <app-empower-future></app-empower-future>
  </div>
  <app-next-generation></app-next-generation>
  <app-flexible-learning></app-flexible-learning>
  <app-enhance></app-enhance>
  <app-excutive-coach></app-excutive-coach>
  <app-choose-us></app-choose-us> 
  <app-success-stories></app-success-stories>

  <app-footer></app-footer>
 </div>